module.exports = __webpack_public_path__ + "static/media/thermometer.127addb8.svg";